import Service from "../../../Services/index";

const TaxPayoff = {
    namespaced: true,
    state: {
        tax_payoff_list: [],
    },
    mutations: {
        GET_TAX_PAYOFF_LIST: (state, res) => {
            state.tax_payoff_list = res.data;
        }

    },
    actions: {
        getTaxPayoffList({commit}, page = 1) {
            return Service.TaxPayoff.getTaxInvoice(page).then(res => {
                commit("GET_TAX_PAYOFF_LIST", res);
            })
        },
        createTaxPayoff({commit}, data) {
            return Service.TaxPayoff.createTaxInvoice(data).then(res => {
                //console.log("create success");
            });
        }
    }
};

export default TaxPayoff;
